module.exports = __webpack_public_path__ + "img/33Truman.9e45577d.png";